const PA_SUBJECT_VALUES = {
  SCIENCE: 'Science',
  OTHER: 'Other Subjects',
  MATHEMATICS: 'Mathematics',
  SOCIAL_STUDIES: 'Social Studies',
  ELA: 'ELA',
  COMPUTER_SCIENCE: 'Computer Science',
}

const PA_SUBJECT_NAMES = [
  PA_SUBJECT_VALUES.MATHEMATICS,
  PA_SUBJECT_VALUES.ELA,
  PA_SUBJECT_VALUES.SCIENCE,
  PA_SUBJECT_VALUES.SOCIAL_STUDIES,
  PA_SUBJECT_VALUES.COMPUTER_SCIENCE,
  PA_SUBJECT_VALUES.OTHER,
]

const PA_GRADES_MAP = {
  PRE_KINDERGARTEN: {
    description: 'PreKindergarten',
    code: 'TK',
  },
  KINDERGARTEN: {
    description: 'Kindergarten',
    code: 'K',
  },
  GRADE_1: {
    description: 'Grade 1',
    code: '1',
  },
  GRADE_2: {
    description: 'Grade 2',
    code: '2',
  },
  GRADE_3: {
    description: 'Grade 3',
    code: '3',
  },
  GRADE_4: {
    description: 'Grade 4',
    code: '4',
  },
  GRADE_5: {
    description: 'Grade 5',
    code: '5',
  },
  GRADE_6: {
    description: 'Grade 6',
    code: '6',
  },
  GRADE_7: {
    description: 'Grade 7',
    code: '7',
  },
  GRADE_8: {
    description: 'Grade 8',
    code: '8',
  },
  GRADE_9: {
    description: 'Grade 9',
    code: '9',
  },
  GRADE_10: {
    description: 'Grade 10',
    code: '10',
  },
  GRADE_11: {
    description: 'Grade 11',
    code: '11',
  },
  GRADE_12: {
    description: 'Grade 12',
    code: '12',
  },
  GRADE_13: {
    description: 'Grade 13',
    code: '13',
  },
  OTHER: {
    description: 'Other',
    code: 'O',
  },
}

const ALL_PA_GRADES = [
  PA_GRADES_MAP.PRE_KINDERGARTEN,
  PA_GRADES_MAP.KINDERGARTEN,
  PA_GRADES_MAP.GRADE_1,
  PA_GRADES_MAP.GRADE_2,
  PA_GRADES_MAP.GRADE_3,
  PA_GRADES_MAP.GRADE_4,
  PA_GRADES_MAP.GRADE_5,
  PA_GRADES_MAP.GRADE_6,
  PA_GRADES_MAP.GRADE_7,
  PA_GRADES_MAP.GRADE_8,
  PA_GRADES_MAP.GRADE_9,
  PA_GRADES_MAP.GRADE_10,
  PA_GRADES_MAP.GRADE_11,
  PA_GRADES_MAP.GRADE_12,
  PA_GRADES_MAP.GRADE_13,
  PA_GRADES_MAP.OTHER,
]

module.exports = {
  PA_SUBJECT_VALUES,
  PA_GRADES_MAP,
  PA_SUBJECT_NAMES,
  ALL_PA_GRADES,
}
